import type { ReactNode } from "react";

// 메모(댓글) 글리프다(말풍선). c6 는 도메인 아이콘을 런타임에 제공하지 않으므로 앱에서 정의한다.
export function MemoIcon(): ReactNode {
  return (
    <svg
      aria-hidden="true"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.5 3.5h11a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6l-3 2.5V11.5H2.5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z" />
    </svg>
  );
}
